import React, { Component, Fragment } from 'react';
import { debounce, cloneDeep } from 'lodash';
import { Avatar, Button, Col, Form, Input, Modal, Row, Select, Table,
     Tooltip, InputNumber, message, Checkbox, Tag } from 'antd';
import { CalendarOutlined, DeleteOutlined } from '@ant-design/icons';
import DatePicker from 'react-modern-calendar-datepicker';
import moment from "moment-jalaali";
import { PriceFormat, SearchFormat } from '../scripts/helpers';
import { Constants } from '../scripts/settings';
import API from '../scripts/api';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class ReminderPayForm extends Component {
    constructor() {
        super();

        this.state = {
            selectedUser: [],
            users: [],
            cities: [],
            neighborhoods: [],
            selectedCity: null,

        };

        this.formRef = React.createRef();

    }

    handleDate = (date, obj) => {
        const state = {};
        state[obj] = date;
        this.formRef.current.setFieldsValue(state);
    };

    handleSubmit = () => {
        this.formRef.current.validateFields()
            .then(values => {
                // const { date } = values;
                
                // values.date = moment(`${date.year}-${date.month}-${date.day}`, Constants.jDateFormat).format(Constants.dateFormat);
               
               values.cashData = values.cashData?.map(i => ({
                    ...i,
                    date: moment(`${i.date.year}-${i.date.month}-${i.date.day}`, "jYYYY-jM-jD").format("YYYY-MM-DD")
                }));

                values.checkData = values.checkData?.map(i => ({
                    ...i,
                    date: moment(`${i.date.year}-${i.date.month}-${i.date.day}`, "jYYYY-jM-jD").format("YYYY-MM-DD")
                }));
                this.props.onSubmit(values);

            });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();
        this.setState({ products: [], selected: [] });
    }

    handleDidMount = async (data = {}) => {
         
        let user = data.user
        const cloneData = cloneDeep(data);
        this.cities()

        if (cloneData.id) {
            const date = moment(cloneData.date);

            // cloneData.date = { day: date.jDate(), month: date.jMonth() + 1, year: date.jYear() };
              // ✅ تبدیل تاریخ cashData
        if (cloneData.cashData) {
            cloneData.cashData = cloneData.cashData.map(item => {
                const d = moment(`${item.date.year}-${item.date.month}-${item.date.day}`, "YYYY-M-D");
                return {
                    ...item,
                    date: {
                        day: d.jDate(),
                        month: d.jMonth() + 1,
                        year: d.jYear()
                    }
                }
            });
        }

           // ✅ تبدیل تاریخ checkData
        if (cloneData.checkData) {
            cloneData.checkData = cloneData.checkData.map(item => {
                const d = moment(`${item.date.year}-${item.date.month}-${item.date.day}`, "YYYY-M-D");
                return {
                    ...item,
                    date: {
                        day: d.jDate(),
                        month: d.jMonth() + 1,
                        year: d.jYear()
                    }
                }
            });
        }
            this.setState({ editMode: true });
          
             let users = [
                {
                    id: user.id,
                    name: user.name ?? "",
                    family: user.family ?? "",
                    phone: user.phone,
                    value:  user.phone,
                    count: 1
                }
            ]
             this.setState({users: users, selectedUser: users})
             this.handleSelectUser(user.id, false)
            this.formRef.current.setFieldsValue(cloneData);


        } else {
            this.setState({ editMode: false });
        }
    }

    handleFilterUsers = (input, option) => {
            console.log("handleFilterUsers")
            const value = SearchFormat(input);
            const split = value.split(' ');
            let valid = option.code.indexOf(value) >= 0;

            split.forEach(val => {
            valid = valid || option.code.indexOf(val) >= 0;
            });

            return valid;
    }

    handleSearchUsers = (value) => {

        if (value) {
        // this.handleSearchTimeOut(value)
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            console.log("into handleSearchUsers", value)
            //search function
            API.user.search({q: SearchFormat(value)}).then((result) => {
            if (result.data && result.data.length) {

                const users = result.data.map(o => {
                return {
                    id: o.id,
                    name: o.name,
                    family: o.family,
                    phone: o.phone,
                    value: value,
                    count: 1

                }
                });

                this.setState({users: users});

            } else {
                this.setState({users: []});
            }
            });

        }, 300);
        }
    }


    handleSelectUser = (value, clear) => {
        console.log("handleSelectUser value", this.state.users)
        console.log("handleSelectUser clear",  value)
        if (value) {
        const { users, selectedUser } = this.state;
        const user = selectedUser.find(o => o.id === value);
        if (user) {
            this.handleCountUser(user.count + 1, user);
        } else {
            const user = users.find(o => o.id === value);
            this.setState({ selectedUser: [...selectedUser, user] });
        }

        if (clear) {
            this.setState({ users: [] });
            // this.voipFormRef.current.resetFields();
            // this.inputRef.current.focus();
        }
        } else {
        this.setState({ users: [] });
        }
    }

    handleCountUser = (value, record) => {
        console.log("handleCountUser")
        const users = [...this.state.users];
        const index = users.findIndex((o) => o.id === record.id);
        const user = users[index];
        user.count = value;
        users.splice(index, 1, user);
        this.setState({...this.state, ...{ users: users }})

    };

     cities = () =>{
            API.city.list(1).then(res => {
                this.setState({
                cities: res.data || []
                });
            });
    }

    handleCityChange = (cityId) => {
        this.setState(
        {
            selectedCity: cityId,
        },
        // () => {
        //     this.fetch({page: 1});
        // }
        );
    };
    
    render() {
        const { onCancel, submitting, visible } = this.props;
        const { editMode, users } = this.state;

        const DatePickerInput = (name) => {
                const date = this.formRef.current
                    ? this.formRef.current.getFieldValue(name)
                    : null;

                return ({ ref }) => (
                    <Input
                        value={date ? `${date.year}-${date.month}-${date.day}` : ""}
                        prefix={<CalendarOutlined />}
                        placeholder={Resources.choose}
                        ref={ref}
                        readOnly
                    />
                );
            };
                

        return (
       <Modal
            title={editMode ? Resources.edit : Resources.add}
            visible={visible}
            onOk={this.handleSubmit}
            onCancel={onCancel}
            okText={Resources.confirm}
            cancelText={Resources.cancel}
            okButtonProps={{ loading: submitting }}
            cancelButtonProps={{ disabled: submitting }}
            width="100vw"
            style={{ top: 0, paddingBottom: 0 }}
            bodyStyle={{ height: "calc(100vh - 55px)", overflow: "auto" }}
        >



                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={24}>
                        <Col xs={24} sm={10} md={6}>
                            <Form.Item name="user_id" label={Resources.customer} rules={Rules.required}>
                                <Select
                                    allowClear
                                    filterOption={(input, option) => this.handleFilterUsers(input, option)}
                                    onSearch={this.handleSearchUsers}
                                    onChange={val => this.handleSelectUser(val, false)}
                                    placeholder={Resources.search}
                                    ref={this.inputRef}
                                    // className="ant-select-xl"
                                    showSearch
                                >
                                    {users.map(o => <Select.Option key={o.id} value={o.id} name={o.name + " "+ o.family} code={o.name + o.family + o.phone + o.value}>{o.name + " "+ o.family }</Select.Option>)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={10} md={6}>
                            <Form.Item
                                name="price"
                                label={Resources.newFactor}
                                rules={Rules.required}
                            >
                                <Input
                                    type="text"
                                    dir="ltr"
                                />
                            </Form.Item>
                        </Col>

                         <Col xs={24} sm={10} md={6}>
                            <Form.Item
                                name="outstanding_price"
                                label={Resources.outstanding_price}
                                // rules={Rules.required}
                            >
                                <Input
                                    type="text"
                                    dir="ltr"
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={10} md={6}>
                            <Form.Item label="شهر" name="city_id">
                                <Select
                                    showSearch
                                    allowClear
                                    value={this.state.selectedCity}
                                    placeholder="انتخاب شهر"
                                    onChange={this.handleCityChange}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {this.state.cities.map(c => (
                                        <Select.Option key={c.id} value={c.id} >
                                            {c.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* manage form list for cash reminder */}

                    <Row gutter={24} style={{ marginTop: "10px" }}>
                        <Col xs={24} sm={10} md={12}>
                                <h3 className='formListTitle'>{Resources.Cash}</h3>

                                <Form.List name="cashData">
                                     {(fields, { add, remove }) => (
                                        
                                    <>
                                    
                                        {fields.map(({ key, name, ...restField }) => {
                                            const rawMessages = this.formRef.current?.getFieldValue([
                                                "cashData",
                                                name,
                                                "messages"
                                            ]);

                                            const messages = Array.isArray(rawMessages) ? rawMessages : [];

                                            const sortedMessages = [...messages].sort((a, b) => {
                                                const dateA = a?.created_at
                                                    ? moment(a.created_at, "YYYY-MM-DD HH:mm:ss").valueOf()
                                                    : 0;

                                                const dateB = b?.created_at
                                                    ? moment(b.created_at, "YYYY-MM-DD HH:mm:ss").valueOf()
                                                    : 0;

                                                return dateA - dateB;
                                            });

                                            return <Fragment key={key}>
                                                <Row gutter={16} align="middle">
                                                    {/* مبلغ */}
                                                    <Col xs={24} sm={5} md={5}>
                                                        <Form.Item
                                                            name={[name, "amount"]}
                                                            label={
                                                                    <span>
                                                                    {Resources.price} <span style={{ marginInline: 4 }}>({Resources.rial})</span>
                                                                    </span>
                                                                }
                                                            rules={Rules.required}
                                                            {...restField}
                                                        >
                                                            <InputNumber
                                                                style={{ width: "100%" }}
                                                                placeholder="1,000"
                                                                formatter={(value) =>
                                                                    value
                                                                        ? value
                                                                            .toString()
                                                                            .replace(
                                                                                /\B(?=(\d{3})+(?!\d))/g,
                                                                                ","
                                                                            )
                                                                        : ""
                                                                }
                                                                parser={(value) =>
                                                                    value.replace(/\$\s?|(,*)/g, "")
                                                                }
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    {/* تاریخ (شمسی) */}
                                                    <Col xs={24} sm={5} md={5}>
                                                        <Form.Item
                                                            name={[name, "date"]}
                                                            label={Resources.date}
                                                            rules={Rules.required}
                                                            {...restField}
                                                        >
                                                            <DatePicker
                                                                locale="fa"
                                                                value={
                                                                    this.formRef.current
                                                                        ? this.formRef.current.getFieldValue([
                                                                            "cashData",
                                                                            name,
                                                                            "date",
                                                                        ])
                                                                        : null
                                                                }
                                                                onChange={(value) => {
                                                                    const current =
                                                                        this.formRef.current.getFieldValue(
                                                                            "cashData"
                                                                        ) || [];
                                                                    current[name] = {
                                                                        ...(current[name] || {}),
                                                                        date: value,
                                                                    };
                                                                    this.formRef.current.setFieldsValue({
                                                                        cashData: current,
                                                                    });
                                                                }}
                                                                renderInput={DatePickerInput([
                                                                    "cashData",
                                                                    name,
                                                                    "date",
                                                                ])}
                                                                shouldHighlightWeekends
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    {/* چک‌ باکس پرداخت شد */}
                                                    <Col xs={24} sm={5} md={5}>
                                                        <Form.Item
                                                            name={[name, "is_pay"]}
                                                            valuePropName="checked"
                                                            {...restField}
                                                            style={{ marginTop: 30 }}
                                                        >
                                                            <Checkbox>{Resources.isPay}</Checkbox>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} sm={5} md={5} style={{ marginTop: 28 }}>
                                                            {sortedMessages.map((m, index) => {
                                                                const date = m?.created_at
                                                                    ? moment(m.created_at, "YYYY-MM-DD HH:mm:ss").format("jYYYY/jMM/jDD")
                                                                    : "";

                                                                return (
                                                                    <Tooltip 
                                                                    title={m?.sms || `ارسال: ${date}`}
                                                                    key={m?.id || index}>
                                                                        <Tag color="blue" style={{ marginBottom: 4 }}>
                                                                            یادآور {index + 1} 
                                                                            - {date}
                                                                        </Tag>
                                                                    </Tooltip>
                                                                );
                                                            })}
                                                        </Col>


                                                    {/* حذف */}
                                                    <Col
                                                        xs={24}
                                                        sm={2}
                                                        md={2}
                                                        style={{ textAlign: "center" }}
                                                    >
                                                        <Button
                                                            type="link"
                                                            onClick={() => remove(name)}
                                                            style={{
                                                                marginTop: 30,
                                                                padding: 0,
                                                                color: "red",
                                                            }}
                                                        >
                                                            <DeleteOutlined />
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        })}

                                        {/* دکمه افزودن */}
                                        <Col xs={24}>
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => add()} block>
                                                    {Resources.add}
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </>
                                )}
                                </Form.List>

                        </Col>

                         <Col xs={24} sm={10} md={12}>
                             <h3 className='formListTitle'>{Resources.Check}</h3>

                           <Form.List name="checkData">
                                {(fields, { add, remove }) => (
                                    <>
                                        {fields.map(({ key, name, ...restField }) => (
                                            <Fragment key={key}>
                                                <Row gutter={16} align="middle">
                                                    {/* مبلغ */}
                                                    <Col xs={24} sm={7} md={7}>
                                                        <Form.Item
                                                            name={[name, "amount"]}
                                                            label={
                                                                    <span>
                                                                    {Resources.price} <span style={{ marginInline: 4 }}>({Resources.rial})</span>
                                                                    </span>
                                                                }
                                                            rules={Rules.required}
                                                            {...restField}
                                                        >
                                                            <InputNumber
                                                                style={{ width: "100%" }}
                                                                placeholder="1,000"
                                                                formatter={(value) =>
                                                                    value
                                                                        ? value
                                                                            .toString()
                                                                            .replace(
                                                                                /\B(?=(\d{3})+(?!\d))/g,
                                                                                ","
                                                                            )
                                                                        : ""
                                                                }
                                                                parser={(value) =>
                                                                    value.replace(/\$\s?|(,*)/g, "")
                                                                }
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    {/* تاریخ (شمسی) */}
                                                    <Col xs={24} sm={7} md={7}>
                                                        <Form.Item
                                                            name={[name, "date"]}
                                                            label={Resources.date}
                                                            rules={Rules.required}
                                                            {...restField}
                                                        >
                                                            <DatePicker
                                                                locale="fa"
                                                                value={
                                                                    this.formRef.current
                                                                        ? this.formRef.current.getFieldValue([
                                                                            "checkData",
                                                                            name,
                                                                            "date",
                                                                        ])
                                                                        : null
                                                                }
                                                                onChange={(value) => {
                                                                    const current =
                                                                        this.formRef.current.getFieldValue(
                                                                            "checkData"
                                                                        ) || [];
                                                                    current[name] = {
                                                                        ...(current[name] || {}),
                                                                        date: value,
                                                                    };
                                                                    this.formRef.current.setFieldsValue({
                                                                        checkData: current,
                                                                    });
                                                                }}
                                                                renderInput={DatePickerInput([
                                                                    "checkData",
                                                                    name,
                                                                    "date",
                                                                ])}
                                                                shouldHighlightWeekends
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    {/* چک‌ باکس پرداخت شد */}
                                                    <Col xs={24} sm={6} md={6}>
                                                        <Form.Item
                                                            name={[name, "is_pay"]}
                                                            valuePropName="checked"
                                                            {...restField}
                                                            style={{ marginTop: 30 }}
                                                        >
                                                            <Checkbox>{Resources.isPay}</Checkbox>
                                                        </Form.Item>
                                                    </Col>


                                                    {/* حذف */}
                                                    <Col
                                                        xs={24}
                                                        sm={2}
                                                        md={2}
                                                        style={{ textAlign: "center" }}
                                                    >
                                                        <Button
                                                            type="link"
                                                            onClick={() => remove(name)}
                                                            style={{
                                                                marginTop: 30,
                                                                padding: 0,
                                                                color: "red",
                                                            }}
                                                        >
                                                            <DeleteOutlined />
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        ))}

                                        {/* دکمه افزودن */}
                                        <Col xs={24}>
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => add()} block>
                                                    {Resources.add}
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </>
                                )}
                            </Form.List>


                        </Col>
                    
                    </Row>

                    {/* end of manage form list cash reminder */}
                </Form>
            </Modal>
        );
    }
};

export default ReminderPayForm;